import moreRequestData from './moreRequestData';

const root = {
	moreRequestData
};

export default root;
